import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export default function UsersTab({ users, fiduciaries, onAssignFiduciary }) {
  return (
    <div className="border border-gray-200 bg-white" data-testid="users-panel">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="font-['Chivo'] font-bold text-lg text-[#111827]">Utilisateurs ({users.length})</h2>
      </div>
      {users.length === 0 ? (
        <div className="p-8 text-center text-gray-500 font-['IBM_Plex_Sans']">Aucun utilisateur</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-[#F9FAFB] border-b border-gray-200">
                <th className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500">Nom</th>
                <th className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500">Email</th>
                <th className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500">Rôle</th>
                <th className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500">Fiduciaire assigné</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="border-b border-gray-100" data-testid={`user-row-${u.id}`}>
                  <td className="px-4 py-3 text-sm text-[#111827] font-semibold">{u.name}</td>
                  <td className="px-4 py-3 text-sm text-gray-600">{u.email}</td>
                  <td className="px-4 py-3">
                    <span className={`text-xs font-bold uppercase px-2 py-0.5 ${u.role === 'admin' ? 'bg-[#E3000F] text-white' : 'bg-gray-100 text-gray-700'}`}>{u.role}</span>
                  </td>
                  <td className="px-4 py-3">
                    <Select value={u.fiduciary_id || 'none'} onValueChange={(v) => onAssignFiduciary(u.id, v === 'none' ? '' : v)}>
                      <SelectTrigger className="rounded-none text-xs h-8 w-48" data-testid={`assign-fiduciary-${u.id}`}><SelectValue placeholder="Aucun" /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="none">Aucun</SelectItem>
                        {fiduciaries.map((f) => <SelectItem key={f.id} value={f.id}>{f.name}</SelectItem>)}
                      </SelectContent>
                    </Select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
